export const ApiPaths = {
  login: `/login`,
  register: `/register`,
  registrationSettings: `/registration-settings`,
  registerfield: "/registerfields",
  verifyUsername: `/verify-username`,
  verifySponsor: `/verify-sponsor`,
  checkSponsor: `/check_username`,
  checkUsername: `/check-username`,
  getProfile: `/get_profile`,
  getWallets: `/get_wallets`,
  getTodayIncomeSummary: "/today-income-summary",
  getDashboardSummary: "/dashboard-summary",
  changePassword: `/update-password`,
  updateProfile: `/update-profile`,
  paymentRequest: "/payment-request",
  getPaymentMethod: "/get-payment-method",
  getPaymentTransaction: `/get-payment-transaction`,
  topUp: `/topup`,
  placeOrder: "/place-order-with-dap",
  confirmOrder: "/confirm-order-with-dap",
  getTeams: `/get_team_section`,
  getTeamStatement: "/team-statement",
  withdraw: "/withdraw",
  getPackages: "/get-all-package",
  investWithGateway: "/invest-with-gateway",
  gatewayPaymentStatus: "/gateway-payment-status",
  getLevels: "/get_level_team",
  getOrders: "/get_orders",
  // Rank & Salary (V1..V12): the ladder, the 50:50 leg split, the per-direct legs and the
  // salary cycle counters, all in one call.
  getRankSalaryProgress: "/rank-salary-progress",
  // Deprecated — serves the same ladder under the retired Bronze->Crown field names.
  getRanks: "/get-ranks",
  getALlTeam: "/get_all_team",
  generationTree: "/get_genealogy_tree",
  claimReward: "/claim_reward",
  claimRoi: "/claim-roi",
  getBankDetails: "/submit-bank-kyc",
  getPanCardDetails: "/submit-pan-kyc",
  getAddressDetails: "/submit-address-kyc",
  bonanzaData: "/get-bonanza",
  getCompanyDetails: "/get-company-info",
  getFloxyPayMethod: "/floxypay-payment-request",
  sendOTP: "/send-otp",
  forgotPassword: "/forgot-password",
  getManualRequest: "/manual-payment-status",
  createTicket: "/create-ticket",
  getTickets: "/get-ticket",
  getTicketById: "/get-ticket/:id",
  addComment: "/add-comment/:id",
  getBankKycDetails: "/check-kyc",
  getFirstId: "/get_first_profile",
  getNews: "/get-all-news",
  getTotalInvestment: "/get-total-investment",
  getUserOrders: "/get-user-orders",
  claimPrincipal: "/claim-principal",
  principalClaimEligibility: "/principal-claim-eligibility",

  // Web3 Details APIs
  addWeb3Details: "/add-web3-details",
  getWeb3Details: "/get-web3-details",
  getWeb3Settings: "/get-web3-settings",
  deleteWeb3Details: "/delete-web3-details",
  setDefaultWeb3Details: "/set-default-web3-details",
  
  // Withdrawal APIs
  cancelWithdrawalRequest: "/cancel-withdrawal-request",
  getWithdrawalSettings: "/get-withdrawal-settings",
  
  // Trading APIs
  getTrades: "/get-trades",
  getProfitableTransactions: "/api/transactions/profitable",
  
  // Telegram Authentication
  telegramAuth: `/telegram-auth`,
  
  // Package Progress APIs
  getPackageProgress: "/get-package-progress",
  
  // Booster Progress APIs
  getBoosterProgress: "/get-booster-progress",
  
  // Bonanza APIs
  getBonanzaList: "/bonanza/list",
  getBonanzaDetail: "/bonanza/:id",
  
  // ROI Cap Progress API
  getRoiCapProgress: "/roi-cap-progress",

  // Compounding ROI on main wallet
  getCompoundingRoiStatus: "/compounding-roi-status",

  // ROI Tier Progress API
  getRoiTierProgress: "/roi-tier-progress",
  
  // Gateway Fund Addition APIs
  addFundWithGateway: "/add-fund-with-gateway",
  gatewayFundPending: "/gateway-fund-pending",
  cancelGatewayFundRequest: "/cancel-gateway-fund-request",
  
  // P2P Fund Transfer APIs
  fundTransfer: "/fund_transfer",

  // Reinvest Wallet -> own Main Wallet self transfer. ROI and Reinvest Income both credit
  // 100% to the Reinvest Wallet, which is not withdrawable, so this is how a member moves
  // earnings somewhere they can withdraw from.
  compoundTransfer: "/compound-transfer",
};
